var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardinalityOneOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16H19.5M10.5 19H7.5C6.4 19 5.5 18.1 5.5 17V15C5.5 13.9 6.4 13 7.5 13H10.5C11.6 13 12.5 13.9 12.5 15V17C12.5 18.1 11.6 19 10.5 19ZM21.5 19H24.5C25.6 19 26.5 18.1 26.5 17V15C26.5 13.9 25.6 13 24.5 13H21.5C20.4 13 19.5 13.9 19.5 15V17C19.5 18.1 20.4 19 21.5 19Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardinalityOneOne);
export default __webpack_public_path__ + "static/media/cardinality-one-one.703a69469e35002e81907c5200a595fb.svg";
export { ForwardRef as ReactComponent };